import React from "react";
import Typography from "@mui/material/Typography";
import { useQuery } from "react-query";
import { sendingCampaigns } from "../../../../../services/actionsCampaigns";
import { Table as CustomTable } from "../../../../../components/Table";
import { PhoneTwo } from "../../../../../utils/masks";

type DetailedProps = {
  id: number;
};

export default function Detailed({ id }: DetailedProps) {
  const detailed = useQuery(["detailed", id], () => sendingCampaigns(id));

  return (
    <CustomTable
      toolbar={false}
      pageSize={7}
      data={detailed.data || []}
      isLoading={detailed.isFetching}
      headerStyle={{
        backgroundColor: "#F3F4FB",
        padding: "10px 0px",
      }}
      columns={[
        {
          field: "status_envio_externo",
          title: "Status",
          align: "center",
          render: (rowData) => (
            <Typography>{rowData.status_envio_externo}</Typography>
          ),
        },

        {
          field: "numero",
          title: "Número",
          align: "center",
          render: (rowData) => (
            <Typography>{PhoneTwo(rowData.destinatario)}</Typography>
          ),
        },
      ]}
    />
  );
}
